import React from "react";
import "./SessionTimeoutModal.css";

export default function SessionTimeoutModal({ open, onLogout }) {
  if (!open) return null;

  return (
    <div className="session-backdrop">
      <div className="session-card">
        <div className="session-icon">
          🔒
        </div>

        <h2>Session Timed Out</h2>

        <p>
          For your security, your session has expired due to inactivity.
          <br />
          Please log in again to continue using MyAhana Portal.
        </p>

        <button className="session-btn" onClick={onLogout}>
          Login Again
        </button>

        <span className="session-footer">
          This helps us keep your data safe.
        </span>
      </div>
    </div>
  );
}
